import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const RegulationUpdateCard = ({ update }) => {
  const getImpactColor = () => {
    switch (update?.impact) {
      case 'high':
        return 'text-error';
      case 'medium':
        return 'text-warning';
      case 'low':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5">
      <div className="flex items-start gap-3 mb-4">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="Shield" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2 mb-2">
            <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-2">{update?.title}</h4>
            <span className="text-xs text-muted-foreground whitespace-nowrap">{update?.date}</span>
          </div>
          <p className="text-xs md:text-sm text-muted-foreground mb-3 line-clamp-3">{update?.description}</p>
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <span className="px-2 py-1 rounded text-xs font-medium bg-primary/10 text-primary">
              {update?.organization}
            </span>
            <span className={`px-2 py-1 rounded text-xs font-medium ${getImpactColor()} bg-current/10`}>
              {update?.impact?.toUpperCase()} IMPACT
            </span>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" fullWidth iconName="FileText" iconPosition="left">
          Read Full Update
        </Button>
        <Button variant="ghost" size="sm" iconName="Share2" className="flex-shrink-0" />
      </div>
    </div>
  );
};

export default RegulationUpdateCard;